import { Box, ButtonProps, Theme } from "@mui/material";
import MuiButton from "@mui/material/Button";
import React, { FC } from "react";
import styled from "styled-components";
import { CommentIcon, DownVoteIcon, UpVoteIcon } from "icons";

interface IUpvoteButton extends ButtonProps {
  isUpvoted?: number;
}

interface IDownvoteButton extends ButtonProps {
  isDownvoted?: number;
}

interface PostActionsComposition {
  Upvote: FC<IUpvoteButton>;
  Downvote: FC<IDownvoteButton>;
  Comment: FC<ButtonProps>;
  Share: FC<ButtonProps>;
}

const PostActions: FC & PostActionsComposition = ({ children }) => {
  return <Container>{children}</Container>;
};

PostActions.Upvote = ({ isUpvoted = 0, ...rest }) => {
  return (
    <Button
      size="small"
      startIcon={<StyledUpVoteIcon isupvoted={isUpvoted} />}
      {...rest}
    >
      Upvote
    </Button>
  );
};
PostActions.Upvote.displayName = "Upvote";

PostActions.Downvote = ({ isDownvoted = 0, ...rest }) => {
  return (
    <Button
      size="small"
      startIcon={<StyledDownVoteIcon isdownvoted={isDownvoted} />}
      {...rest}
    >
      Downvote
    </Button>
  );
};
PostActions.Downvote.displayName = "Downvote";

PostActions.Comment = (props) => {
  return (
    <Button size="small" startIcon={<CommentIcon />} {...props}>
      Comment
    </Button>
  );
};
PostActions.Comment.displayName = "Comment";

PostActions.Share = () => {
  return null;
  // return (
  //   <Button size="small" startIcon={<ShareIcon />} {...props}>
  //     Share
  //   </Button>
  // );
};
PostActions.Share.displayName = "Share";
export default PostActions;

const StyledDownVoteIcon = styled(DownVoteIcon) <{ isdownvoted: number }>`
  stroke-width: 2;
  ${({ isdownvoted }) =>
    isdownvoted &&
    `
  fill: #2094dd;
  `}
`;

const StyledUpVoteIcon = styled(UpVoteIcon) <{ isupvoted: number }>`
  stroke-width: 2;
  ${({ isupvoted }) =>
    isupvoted &&
    `
  fill: #2094dd;
  `}
`;

const Container = styled(Box)`
  ${({ theme }: { theme: Theme }) => `
    display: flex;
    margin: ${theme.spacing(0.5, 0.5, 1, 0.5)};
    
    & .MuiButton-label {
      color: var(--text-color-primary);
    } 

    ${theme.breakpoints.down("sm")} {
        margin: ${theme.spacing(0.5, 0.5, 0.5, 0.5)};
    }
  `}
`;

const Button = styled(MuiButton)`
  ${({ theme }: any) => `
    flex-basis: 33%;

    & .MuiButton-label {
        font-size: 12px;
        font-weight: 600;
    }

    svg {
      stroke-width: 2;
    }

    ${theme.breakpoints.down("sm")} {
        line-height: 1;
        & .MuiButton-label {
            display: flex;
            flex-direction: column;
        }

        & .MuiButton-startIcon {
            margin: 0;
        }
    }
  `}
`;
